import BurgerNav from '../componets/BurgerNav/BurgerNav';
import LanguageBtn from '../componets/LanguageBtn/LanguageBtn';
import { Link } from 'react-router-dom';
import UserBtn from '../componets/UserBtn/UserBtn';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

interface IHeaderProps {}
const StyledContainer = styled.div`
    padding: 0 18px !important;
`;
const Header = (props: IHeaderProps) => {
    const { t } = useTranslation();
    return (
        <>
            <StyledContainer className='it-header-slim-wrapper complementary-2-bg-b2'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='it-header-slim-wrapper-content'>
                                <Link className='d-lg-block navbar-brand' to={'/'}>
                                    {t('generic.title')}
                                </Link>
                                <div className='it-header-slim-right-zone complementary-2-bg-b1'>
                                    <LanguageBtn />
                                    <UserBtn />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </StyledContainer>
            <div className='it-header-center-wrapper complementary-2-bg-b1'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='it-header-center-content-wrapper'>
                                <div className='it-brand-wrapper d-flex'>
                                    <Link to={'/'}>
                                        <div className='it-brand-text'>
                                            <div className='it-brand-title'>{t('generic.appTitle')}</div>
                                        </div>
                                    </Link>
                                </div>
                                <div className='it-right-zone complementary-2-bg-b1'>
                                    <BurgerNav />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Header;
